import React, { useEffect, useState } from 'react'

import { Alert, AlertTitle } from '@material-ui/lab'
import AppBar from '@material-ui/core/AppBar'
import Box from '@material-ui/core/Box'
import CardMedia from '@material-ui/core/CardMedia'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'

// Loader
import SyncLoader from "react-spinners/SyncLoader"

// Icons
import HighlightOffIcon from '@material-ui/icons/HighlightOff'

// Styles
import { makeStyles } from '@material-ui/core/styles'

// Translation
import { Language } from '../../Translation'

// Components
import Header from '../Header/Header'
import DiningPickUp from './DiningPickup'
import DiningDelivery from './DiningDelivery'
import DiningTabPanel from './DiningTabPanel'

// Redux
import { connect } from 'react-redux'
import { fetchMenu } from '../../redux/actions/menuActions'
import { fetchStore } from '../../redux/actions/storeActions'

// React Router
import { useParams } from "react-router"

const useStyles = makeStyles((theme) => ({
  media: {
    height: '100%',
    maxHeight: 300,
    paddingTop: 5,
    paddingBottom: 5,
  },
  name: {
    top: 20,
    marginBottom: 40,
  },
  pickup: {
    top: 20,
    marginBottom: 40,
  },
  box: {
    textAlign: "center",
    marginBottom: 70,
  },
  continueButton: {
    width: "100%",
    backgroundColor: "#003366",
  },
  loading: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const DiningOption = ({ storeData, clientData, fetchMenu, fetchStore }) => {

  console.log(navigator.cookieEnabled)

  // Loader
  const [loading] = useState(true)

  const [value, setValue] = useState(0)
  const classes = useStyles()

  const { language } = clientData
  const { store } = storeData
  const { name } = useParams()

  useEffect(() => {
    fetchMenu(name)
    fetchStore(name)
    // eslint-disable-next-line
  }, [])

  // Week Day Array
  let weekday = new Array(7)
  weekday[0] = "SUNDAY"
  weekday[1] = "MONDAY"
  weekday[2] = "TUESDAY"
  weekday[3] = "WEDNESDAY"
  weekday[4] = "THURSDAY"
  weekday[5] = "FRIDAY"
  weekday[6] = "SATURDAY"

  const WelcomeMessage = () => {

    return (
      <div>
        <Alert severity="info">
          <AlertTitle>Info</AlertTitle>
          {language === "fr" ?
            <strong>{store.WELCOME_FR}</strong>
            :
            <strong>{store.WELCOME_EN}</strong>
          }
        </Alert>
      </div>
    )
  }

  const handleStoreSchedule = () => {

    let storeStatus = true

    let date = new Date()
    let today = date.getDay()
    let hours = date.getHours()
    let minutes = date.getMinutes()

    let openingTime = store[weekday[today]].split('@')
    let openTime = openingTime[0].split(':')
    let closeTime = openingTime[1].split(':')

    let totalCurrentTime = parseInt(hours * 3600 + minutes * 60)
    let totalOpenTime = parseInt(openTime[0] * 3600 + openTime[1] * 60)
    let totalCloseTime = parseInt(closeTime[0] * 3600 + closeTime[1] * 60)

    if (totalCurrentTime < totalOpenTime || totalCurrentTime > totalCloseTime) {
      storeStatus = false
    }

    return storeStatus

  }

  const handleStoreCloseMessage = () => {

    let date = new Date()
    let today = date.getDay()
    let openingTime = store[weekday[today]].split('@')

    return (
      <Box className={classes.box} p={1}>
        <Card>
          <CardContent>
            <>
              <HighlightOffIcon style={{ color: "red", fontSize: "11rem" }} />
              <br />
              <br />
              <Typography variant="h4">{language === "fr" ? store.TIME_CLOSE_FR : store.TIME_CLOSE_EN}</Typography>
              <br />
              <Typography variant="h4">{openingTime[0]} - {openingTime[1]}</Typography>
            </>
          </CardContent>
        </Card>
      </Box>
    )
  }

  const addTabPanels = () => {

    let counter = 0
    let tabPanels = []

    if (store.ACTIVE_PICKUP === true) {
      tabPanels.push(
        <DiningTabPanel key={"pickup"} value={value} index={counter}>
          <DiningPickUp />
        </DiningTabPanel>
      )
      counter++
    }

    if (store.ACTIVE_DELIVERY === true) {
      tabPanels.push(
        <DiningTabPanel key={"delivery"} value={value} index={counter} >
          <DiningDelivery />
        </DiningTabPanel>
      )
    }

    return tabPanels

  }

  if (store.length === 0) {
    return (<div className={classes.loading}>
      <SyncLoader
        size={40}
        color={"#123abc"}
        loading={loading}
      />
    </div>)
  }

  return (
    <>
      <Header title={store.CLIENT_NAME} languageIcon={true} phoneIcon={true} />
      <CardMedia
        component="img"
        alt="Company Logo"
        className={classes.media}
        image={store.CLIENT_IMG}
      />
      {
        handleStoreSchedule()
          ?
          <>
            <WelcomeMessage />
            <AppBar style={{ position: 'sticky', backgroundColor: "#003366" }}>
              <Tabs
                value={value}
                onChange={(event, value) => {
                  setValue(value)
                }}
                indicatorColor="secondary"
                variant="fullWidth"
                scrollButtons="on"
              >
                {store.ACTIVE_PICKUP === true && <Tab style={{ fontSize: "large", fontWeight: "bold" }} label={Language.DiningPickUp[language]} />}
                {store.ACTIVE_DELIVERY === true && <Tab style={{ fontSize: "large", fontWeight: "bold" }} label={Language.DiningDelivery[language]} />}
              </Tabs>
            </AppBar>
            {addTabPanels()}
          </>
          :
          handleStoreCloseMessage()
      }

    </>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenu: (location) => {
      dispatch(fetchMenu(location))
    },
    fetchStore: (location) => {
      dispatch(fetchStore(location))
    }
  }
}

const mapStateToProps = state => {
  return {
    storeData: state.storeData,
    clientData: state.clientData
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DiningOption)